import { useState, useRef, useEffect, useCallback } from 'react';

export default function CheckboxDropdown({
  label,
  options = [],
  selectedValues = [],
  onChange,
  className = '',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // 外部クリックで閉じる
  useEffect(() => {
    if (!isOpen) return;
    const handleMouseDown = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [isOpen]);

  const filteredOptions = options.filter((o) => {
    const val = typeof o === 'object' ? o.value : o;
    return val !== '' && val !== null && val !== undefined;
  });

  /* istanbul ignore next -- filteredOptions が空文字/null/undefined を除外済みのため value の ?? '' フォールバックは到達不能な防御ガード */
  const toOption = (o) =>
    typeof o === 'object'
      ? { value: o.value ?? '', label: o.label ?? o.value ?? '' }
      : { value: o ?? '', label: o ?? '' };

  const toggleValue = useCallback(
    (val) => {
      if (!onChange) return;
      if (selectedValues.includes(val)) {
        onChange(selectedValues.filter((v) => v !== val));
      } else {
        onChange([...selectedValues, val]);
      }
    },
    [onChange, selectedValues],
  );

  const selectAll = useCallback(() => {
    if (!onChange) return;
    onChange(filteredOptions.map((o) => toOption(o).value));
  }, [onChange, filteredOptions]);

  const clearAll = useCallback(() => {
    if (!onChange) return;
    onChange([]);
  }, [onChange]);

  const hasSelection = selectedValues.length > 0;
  const triggerClass = [
    'pm-filter-dropdown-trigger',
    hasSelection ? 'has-selection' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={['pm-filter-item--multiselect', className]
        .filter(Boolean)
        .join(' ')}
      ref={wrapperRef}
    >
      <span>{label}</span>
      <button
        className={triggerClass}
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
      >
        <span>
          {hasSelection ? `${selectedValues.length}件選択` : 'すべて'}
        </span>
        <span className="pm-filter-dropdown-arrow">&#9660;</span>
      </button>
      {isOpen && (
        <div className="pm-filter-dropdown-panel">
          <div className="pm-filter-dropdown-actions">
            <button onClick={selectAll} type="button">
              すべて選択
            </button>
            <button onClick={clearAll} type="button">
              すべて解除
            </button>
          </div>
          <div className="pm-filter-dropdown-list">
            {filteredOptions.map((raw) => {
              const opt = toOption(raw);
              return (
                <label className="pm-filter-dropdown-option" key={opt.value}>
                  <input
                    checked={selectedValues.includes(opt.value)}
                    onChange={() => toggleValue(opt.value)}
                    type="checkbox"
                  />
                  <span>{opt.label}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
